var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 23,
    viewBox: "0 0 45 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 23,
    fill: "#E7E0C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0039 4H43.0039V9.9999H37.0039V4Z",
    fill: "#D68653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7031 19.4061C28.3148 19.4061 28 19.0913 28 18.703C28 18.6672 28.0038 17.8157 28.326 16.9562C28.7991 15.6947 29.7321 15 30.9531 15C32.291 15 32.9828 15.4612 33.5932 15.8682C34.1227 16.2212 34.541 16.5001 35.4531 16.5001C36.1958 16.5001 36.7434 16.313 37.273 16.1321C38.1826 15.8214 39.2135 15.4691 40.4503 16.7061C40.7637 17.0194 41.0595 17.1906 41.2422 17.1641C41.4043 17.1404 41.5431 16.9459 41.579 16.8796C41.5758 16.8856 41.5743 16.8888 41.5743 16.8888L42.8321 17.5177C42.7868 17.6083 42.3639 18.4066 41.4715 18.5515C40.8068 18.6596 40.1286 18.3731 39.456 17.7004C38.8388 17.0833 38.5811 17.1713 37.7276 17.4629C37.1492 17.6605 36.4293 17.9064 35.4531 17.9064C34.1153 17.9064 33.4235 17.4452 32.8131 17.0382C32.2836 16.6852 31.8652 16.4063 30.9531 16.4063C30.5586 16.4063 29.9935 16.5144 29.6427 17.4501C29.4126 18.0635 29.4063 18.697 29.4063 18.7031C29.4063 19.0913 29.0914 19.4061 28.7031 19.4061Z",
    fill: "#C7B78B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.203 13.6567H2.70313C2.31482 13.6567 2 13.3419 2 12.9536C2 12.5653 2.31482 12.2505 2.70313 12.2505H13.2032C13.5915 12.2505 13.9063 12.5653 13.9063 12.9536C13.9062 13.3419 13.5913 13.6567 13.203 13.6567Z",
    fill: "#C7B78B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.453 16.6567H2.70313C2.31482 16.6567 2 16.3419 2 15.9536C2 15.5653 2.31482 15.2505 2.70313 15.2505H18.453C18.8414 15.2505 19.1562 15.5653 19.1562 15.9536C19.1562 16.3419 18.8414 16.6567 18.453 16.6567Z",
    fill: "#C7B78B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.453 19.6563H2.70313C2.31482 19.6563 2 19.3414 2 18.9531C2 18.5648 2.31482 18.25 2.70313 18.25H18.4532C18.8415 18.25 19.1563 18.5648 19.1563 18.9531C19.1563 19.3414 18.8414 19.6563 18.453 19.6563Z",
    fill: "#C7B78B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7012 5.40625H24.4512C24.0629 5.40625 23.748 5.09143 23.748 4.70313C23.748 4.31482 24.0629 4 24.4512 4H32.7012C33.0895 4 33.4043 4.31482 33.4043 4.70313C33.4043 5.09143 33.0895 5.40625 32.7012 5.40625Z",
    fill: "#C7B78B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7012 8.40625H24.4512C24.0629 8.40625 23.748 8.09143 23.748 7.70313C23.748 7.31482 24.0629 7 24.4512 7H32.7012C33.0895 7 33.4043 7.31482 33.4043 7.70313C33.4043 8.09143 33.0895 8.40625 32.7012 8.40625Z",
    fill: "#C7B78B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00391 4H6.00391V7.00001H3.00391V4Z",
    fill: "#D68653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.aa7a4f58e11cc51a4bb0a984844a6361.svg";
export { ForwardRef as ReactComponent };